import { useState } from 'react';
import LoadError from '@/components/ui/LoadError.tsx';
import { tourRoute } from '@/features/dashboard/tours/routes/tourRoute.ts';
import useGetTourDashboardOptions from '@/features/dashboard/tours/hooks/useGetTourDashboardOptions.ts';
import { OPTIONS_TAB_KEYS } from '@/features/dashboard/attention/types/AttentionKey.utils.ts';
import TourAttentionPanel from '@/features/dashboard/tours/components/attention/TourAttentionPanel.tsx';
import OptionFilterCard from '@/features/dashboard/tours/components/options/OptionFilterCard.tsx';
import OptionOccupancyCard from '@/features/dashboard/tours/components/options/OptionOccupancyCard.tsx';
import {
  OptionFilter,
  toggleOptionFilter,
} from '@/features/dashboard/tours/components/options/optionFilters.ts';
import TourOptionsTabSkeleton from '@/features/dashboard/tours/pages/TourOptionsTabSkeleton.tsx';

/**
 * Opcje dodatkowe wyjazdu: co wymaga uwagi, kto co wybrał i ile miejsc
 * zostało. Kto dokładnie siedzi w wariancie, mówi tabela krzyżowa — imienna
 * lista pod każdą opcją powtarzała tę samą informację drugi raz.
 *
 * Zaznaczone warunki siedzą w stanie ekranu, a nie w adresie — to narzędzie do
 * jednorazowego pytania („kto ma kajaki i nocleg?”), nie widok do odesłania.
 */
const TourOptionsTab = () => {
  const { tourId } = tourRoute.useParams();
  const { data, isPending, isError } = useGetTourDashboardOptions(tourId);
  const [filters, setFilters] = useState<OptionFilter[]>([]);

  if (isPending) return <TourOptionsTabSkeleton />;
  if (isError || !data)
    return <LoadError subject="opcji dodatkowych wyjazdu" />;

  return (
    <div className="flex flex-col gap-4">
      <TourAttentionPanel
        tourId={tourId}
        title="Wymaga uwagi — opcje"
        keys={OPTIONS_TAB_KEYS}
      />

      <OptionFilterCard
        options={data.options}
        participants={data.participants}
        filters={filters}
        onToggleFilter={(optionId, variantId) =>
          setFilters((current) =>
            toggleOptionFilter(current, optionId, variantId),
          )
        }
        onClearFilters={() => setFilters([])}
      />

      <OptionOccupancyCard options={data.options} />
    </div>
  );
};

export default TourOptionsTab;
